<template>
    <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar mr-2">
                    <img src="https://apim.innolux.com/2fa-query/img/avatars/default-user-avatar.jpg" class="c-avatar-img" />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownItem @click="logout"> <CIcon name="cil-account-logout" /> {{ i18n.logout.button }} </CDropdownItem>
    </CDropdown>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { getUrlProject, getUrlLang, getUrlQuery } from '@/services/check';
import { getLangString } from '@/services/lang';

export default {
    name: 'TheHeaderDropdownAccnt',
    data() {
        return {
            itemsCount: 42,
            url: window.location.href.split('/').slice(0, 3).join('/'),
            i18n: null,
        };
    },
    methods: {
        ...mapMutations('account', ['removeAllState', 'removeAllStorage']),
        logout() {
            this.removeAllStorage();
            this.removeAllState();
            this.$router.push(`/2fa-query/auth/login${getUrlQuery(getUrlProject(), getUrlLang())}`);
        },
    },
    created() {
        this.i18n = getLangString(getUrlLang());
    },
};
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
</style>
